'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.hoursUntil;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/hoursUntil.js
// module id = 195
// module chunks = 1